import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Tag } from '@duxton-web/ui';
import { STATUS } from 'omega-rtc/constants/ucd';

const BACKGROUND_COLOR_MAP = {
  [STATUS.draft]: 'grey',
  [STATUS.pendingApproval]: 'grey',
  [STATUS.pendingCreation]: 'grey',
  [STATUS.pendingAIP]: 'grey',
  [STATUS.upcoming]: 'blue',
  [STATUS.running]: 'yellow',
  [STATUS.completed]: 'green',
  [STATUS.deactivated]: 'red',
};

const UCDStatusLabel = ({ status, start, end, labelSize }) => {
  const startDate = moment(start).format('YYYY-MM-DD');
  const endDate = moment(end).format('YYYY-MM-DD');
  const today = moment().format('YYYY-MM-DD');
  let displayStatus = _.toUpper(status);
  if (
    displayStatus === STATUS.pendingApproval ||
    displayStatus === STATUS.pendingCreation ||
    displayStatus === STATUS.pendingAIP
  ) {
    displayStatus = 'PENDING';
  } else if (displayStatus === 'ACTIVE') {
    if (today < startDate) {
      displayStatus = STATUS.upcoming;
    } else if (endDate < today) {
      displayStatus = STATUS.completed;
    } else {
      displayStatus = STATUS.running;
    }
  }

  return (
    <Tag color={BACKGROUND_COLOR_MAP[displayStatus]} size={labelSize}>
      {_.upperFirst(_.lowerCase(displayStatus))}
    </Tag>
  );
};

export default UCDStatusLabel;
